import MuiButton, { ButtonProps } from '@mui/material/Button'
import { styled } from '@mui/material/styles'

const ButtonStyled = styled(MuiButton)(({ theme }) => ({
  padding: `0 ${theme.spacing(4)}`,
  height: theme.spacing(8),
  transition: '.3s color, .3s background, .3s border, .3s box-shadow',
  '&.MuiButton-outlinedSizeLarge, &.MuiButton-containedSizeLarge': {
    height: theme.spacing(10),
    padding: `0 ${theme.spacing(4)}`
  },
  '&:active:not(.Mui-disabled)': {
    boxShadow: '0 2px 3px rgba(0, 0, 0, 0.4) inset'
  },
  '&.Mui-disabled': {
    color: 'white',
    backgroundColor: theme.palette.grey['300']
  },
  '&.MuiButton-outlined': {
    borderColor: theme.palette.primary['200'],
    color: theme.palette.primary.main
  },
  '&.MuiButton-outlined:hover:not(.Mui-disabled)': {
    backgroundColor: theme.palette.action.hover
  },
  '&.MuiButton-outlined.Mui-disabled': {
    borderColor: theme.palette.grey['100'],
    color: theme.palette.grey['400'],
    backgroundColor: 'transparent'
  },
  '&.MuiButton-outlined:active:not(.Mui-disabled)': {
    boxShadow: '0 2px 3px rgba(0, 0, 0, 0.1) inset'
  },
  '& .MuiButton-startIcon': {
    marginLeft: '0'
  },
  '&:hover': {
    boxShadow: '0 2px 8px rgba(0,0,0,.2), inset 0 0 0 transparent;'
  },
  a: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'inherit'
  }
}))

export const Button = ({ children, ...props }: ButtonProps): React.ReactElement => (
  <ButtonStyled disableElevation {...props}>
    {children}
  </ButtonStyled>
)
